"use client";

import { useState } from "react";
import { Button } from "components/ui/button";
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "components/ui/popover";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip";
import useDevice from "hooks/useDevice";
import { cn } from "lib/utils";

interface TooltipProps {
  content: any;
  children: any;
  onKnights?: boolean;
}

export default function ProductsTooltip({
  content,
  children,
  onKnights,
}: TooltipProps) {
  const [isOpenTooltip, setIsOpenTooltip] = useState(false);
  const [isOpenPopover, setIsOpenPopover] = useState(false);
  const color = onKnights ? "#2360a0" : "#1F384C";
  const { isMobile } = useDevice();

  const contentStyleAndClassName = {
    className: isMobile
      ? cn(
          `box-border px-6 py-4 max-h-tooltip-available-height w-[250px] overflow-y-auto`,
          "text-xs font-normal text-white rounded-sm leading-4 font-gotham"
        )
      : cn(
          `box-border px-6 py-4 max-h-tooltip-available-height w-[600px] overflow-y-auto`,
          "text-xs font-normal text-white rounded-sm leading-4 font-gotham"
        ),
    style: { background: color },
  };

  const btnClasses = {
    className: "!m-0 hover:bg-transparent text-base text-left !tracking-[0px]",
    style: {
      color: isOpenTooltip || isOpenPopover ? "#2360A0" : "#53565A",
      fontWeight: isOpenTooltip || isOpenPopover ? 400 : 300,
      lineHeight: "28px",
    },
  };

  return (
    <>
      <div className="hidden sm:flex">
        <TooltipProvider delayDuration={0} skipDelayDuration={0}>
          <Tooltip onOpenChange={setIsOpenTooltip} open={isOpenTooltip}>
            <TooltipTrigger asChild>
              <Button size="unstyled" variant="ghost" {...btnClasses}>
                {children}
              </Button>
            </TooltipTrigger>
            <TooltipContent
              {...contentStyleAndClassName}
              align="start"
              side="left"
            >
              {content}
              <TooltipArrow style={{ fill: color }} />
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div
        className={isMobile ? "flex sm:hidden " : "flex sm:hidden max-w-[2vw]"}
      >
        <Popover onOpenChange={setIsOpenPopover} open={isOpenPopover}>
          <PopoverTrigger asChild>
            <Button size="unstyled" variant="ghost" {...btnClasses}>
              {children}
            </Button>
          </PopoverTrigger>
          <PopoverContent noPortal side="top" {...contentStyleAndClassName}>
            {content}
            <PopoverArrow style={{ fill: color }} />
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
}
